/**
 * ソースリンク表示コンポーネント
 * RAG検索結果のソースをリンクとして表示
 */

import { Box, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SourceInfo } from '@/types';
import { isValidHttpUrl } from '@/utils';

const ExternalLinkIcon = () => (
  <Box flexShrink={0} display="inline-flex" width="14px" height="14px">
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  </Box>
);

interface SourceLinksProps {
  sources: SourceInfo[];
}

export const SourceLinks = ({ sources }: SourceLinksProps) => {
  const { t } = useTranslation();

  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <Box mt={3} pt={3} borderTop="1px solid" borderColor="borders.subtle">
      <Text fontSize="xs" color="text.secondary" mb={1}>
        {t('chat.sources', { defaultValue: '参考元' })}
      </Text>
      {sources
        .filter((source) => isValidHttpUrl(source.url))
        .map((source, index) => (
          <Box key={index}>
            <Link
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
              fontSize="sm"
              color="primary"
              textDecoration="underline"
              display="inline-flex"
              alignItems="center"
              gap={1}
              _hover={{ color: 'primaryHover' }}
            >
              {source.title || source.url}
              <ExternalLinkIcon />
            </Link>
          </Box>
        ))}
    </Box>
  );
};
